import Image from 'next/legacy/image';
import { MEDIA_IMAGES } from '../locationPage.constants';
import styles from '../locationPage.module.scss';

const PressBlock = () => (
  <div className="paddingX-small text-align-center marginY-huge1">
    <div className={styles.pressLogos}>
      {MEDIA_IMAGES.map(press => {
        const [name] = press.split('.');

        return (
          <div key={press}>
            <Image alt={name} layout="responsive" height={18} width={100} src={press} className="marginRight-small1" />
          </div>
        );
      })}
    </div>
  </div>
);

export default PressBlock;
